export default {
    // USERS
    LOGIN: "/users/login/",
    // GOOGLE_LOGIN: "/users/googleLogin/",
    OAUTH_REGISTER_LOGIN: '/users/oauthRegisterOrLogin/',
    REGISTER: "/users/register/",
    GET_ME: "/users/me/",
    GET_DWOLLA_BALANCE: "/users/getDwollaBalance",

    // PLEDGE
    GET_PLEDGE_DONATIONS: "/pledge/donations",
    GET_DONATIONS_AND_REEDEEMINGS: "/pledge/getAllDonationsAndRedmptions",
    GET_ORGANIZATIONS: "/pledge/organizations",
    ADD_PLEDGE_ORGANIZATION: "/pledge/organization",
    DONATE: "/pledge/donate",
    DONATE_KOODOS: "/pledge/donateKoodos",

    // REDEEM
    GET_ALL_REDEEMINGS: "/redeemings/",
    REDEEM: "/redeemings/",
    REDEEM_VIA_PAYPAL: "/redeemings/viaPayPal"
};
